function h(tag, className = '', text = '') {
  const el = document.createElement(tag);
  el.setAttribute('class', className);
  if (text) {
    el.appendChild(document.createTextNode(text));
  }
  return el;
}

const buildDialog = (type, options) => new Promise((resolve, reject) => {
  const prev = document.getElementsByClassName('dialog');
  if (prev.length > 0) {
    document.body.removeChild(prev[0]);
  }

  const dialog = h('div', 'dialog');
  const overlay = h('div', options.forced ? 'dialog-overlay-forced' : 'dialog-overlay');
  const closeBtn = h('button', 'dialog-btn-close');
  const content = h('div', 'dialog-content');
  const cTitle = h('h1', 'dialog-title', options.title || '');
  const body = h('div', 'dialog-body');
  const action = h('div', 'dialog-action');
  const okBtn = h('button', 'dialog-btn-ok', options.okText || 'OK');
  const cancelBtn = h('button', 'dialog-btn-cancel', options.cancelText || 'Cancel');
  const input = h('input', 'dialog-input');

  let destroy;
  const ok = () => {
    destroy();
    resolve(input.value);
  };

  const cancel = () => {
    if (options.forced) {
      return;
    }
    destroy();
    reject();
  };

  const hide = (e) => {
    const keyCode = 'which' in e ? e.which : e.keyCode;
    if (keyCode === 27) {
      cancel();
    } else if (keyCode === 13) {
      ok();
    }
  };

  destroy = () => {
    closeBtn.removeEventListener('click', cancel);
    okBtn.removeEventListener('click', ok);
    cancelBtn.removeEventListener('click', cancel);
    overlay.removeEventListener('click', cancel);
    document.removeEventListener('keyup', hide);
    document.body.removeChild(dialog);
  };

  if (!options.forced) {
    overlay.appendChild(closeBtn);
  }
  overlay.addEventListener('click', cancel);
  closeBtn.addEventListener('click', cancel);
  body.appendChild(h('p', 'dialog-sub', options.content || ''));
  action.appendChild(okBtn);

  if (type !== 'alert' && !options.forced) {
    action.appendChild(cancelBtn);
    cancelBtn.addEventListener('click', cancel);
  }

  okBtn.addEventListener('click', ok);

  content.appendChild(cTitle);
  content.appendChild(body);
  content.appendChild(action);

  dialog.appendChild(overlay);
  dialog.appendChild(content);
  document.body.appendChild(dialog);
  dialog.style.display = 'block';
  content.classList.add('dialog-animate');
  if (type === 'prompt') {
    if (options.password) {
      input.setAttribute('type', 'password');
    } else {
      input.setAttribute('type', 'text');
    }
    input.setAttribute('placeholder', options.placeholder || '');
    input.value = options.defaultValue || '';
    input.addEventListener('keyup', hide);
    body.appendChild(input);
    input.focus();
  } else if (type === 'alert') {
    okBtn.focus();
  } else {
    cancelBtn.focus();
  }
  document.addEventListener('keyup', hide);
});

export const confirm = options => buildDialog('confirm', options);
export const prompt = options => buildDialog('prompt', options);
export const alert = options => buildDialog('alert', options);

export function close() {
  const prev = document.getElementsByClassName('dialog');
  if (prev.length > 0) {
    document.body.removeChild(prev[0]);
  }
}
